import React from 'react';
import SEO from '../components/SEO';
import './About.scss';

const RTI: React.FC = () => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Tanda Grampanchayat',
    description:
      'तांडा ग्रामपंचायत - गोंदिया जिल्ह्यातील गोंदिया तालुक्यातील आधिकारिक ग्रामपंचायत',
    url: 'https://gptandagondia.org.in',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Tanda',
      addressLocality: 'Gondia',
      addressRegion: 'Gondia',
      postalCode: '441601',
      addressCountry: 'IN',
    },
  };

  return (
    <div className="about-page">
      <SEO
        title="माहिती अधिकार (RTI) | तांडा ग्रामपंचायत"
        description="माहिती अधिकार कायदा २००५ अंतर्गत तांडा ग्रामपंचायत कडून माहिती कशी मागवायची, अर्जाची पद्धत, शुल्क आणि कालावधी याबद्दल सविस्तर माहिती."
        keywords="माहिती अधिकार, RTI, तांडा ग्रामपंचायत RTI, माहिती अधिकार अर्ज, ग्रामपंचायत माहिती, Tanda Grampanchayat RTI"
        ogTitle="माहिती अधिकार (RTI) | तांडा ग्रामपंचायत"
        ogDescription="तांडा ग्रामपंचायत कडून माहिती अधिकाराद्वारे माहिती मागवण्याची प्रक्रिया, शुल्क आणि कालावधी."
        canonicalUrl="https://gptandagondia.org.in/rti"
        structuredData={structuredData}
      />
      <div className="about-container">
        <h1>माहिती अधिकार (RTI)</h1>
        <p>
          माहिती अधिकार कायदा, २००५ अंतर्गत प्रत्येक नागरिकाला शासकीय कार्यालयांकडून
          ठराविक कालावधीत माहिती मिळवण्याचा मूलभूत अधिकार आहे. तांडा ग्रामपंचायत
          पारदर्शक आणि जबाबदार कारभार करण्यास कटिबद्ध आहे.
        </p>

        <h2>१. माहिती अधिकार काय आहे?</h2>
        <p>
          माहिती अधिकार (Right to Information) म्हणजे नागरिकांना शासनाच्या विविध
          कार्यालयांकडून कागदपत्रे, नोंदी, अहवाल, निर्णय प्रक्रिया याबाबत माहिती मागण्याचा
          कायदेशीर अधिकार. हा अधिकार भारताच्या संविधानात दिलेल्या अभिव्यक्ती स्वातंत्र्याशी
          निगडित आहे.
        </p>

        <h2>२. अर्ज कोणी करू शकतो?</h2>
        <p>
          भारतातील कोणताही नागरिक, स्वतःसाठी किंवा सार्वजनिक हितासाठी माहिती अधिकाराचा
          अर्ज करू शकतो. अर्ज मराठी किंवा इंग्रजी भाषेत साध्या कागदावरही करता येतो.
        </p>

        <h2>३. कोणत्या प्रकारची माहिती मागू शकता?</h2>
        <ul>
          <li>ग्रामपंचायत बैठकांचे ठराव व नोंदी</li>
          <li>विकासकामांचे मंजूर अंदाजपत्रक, खर्च विवरण व मापन पुस्तिका</li>
          <li>विविध शासकीय योजना आणि त्याअंतर्गत लाभार्थ्यांची यादी</li>
          <li>कर, शुल्क, परवाने इ. संदर्भातील नियम व प्रक्रिया</li>
        </ul>

        <h2>४. अर्ज कसा करावा?</h2>
        <p>
          माहिती अधिकार अर्जासाठी निश्चित नमुना आवश्यक नाही; मात्र खालील बाबी स्पष्ट
          लिहाव्यात:
        </p>
        <ul>
          <li>अर्जदाराचे पूर्ण नाव व पत्ता</li>
          <li>मागितलेल्या माहितीचा विषय आणि कालावधी</li>
          <li>संपर्कासाठी मोबाईल क्रमांक / ई‑मेल (असल्यास)</li>
        </ul>
        <p>
          अर्ज तांडा ग्रामपंचायत कार्यालयात प्रत्यक्ष देऊ शकता किंवा अधिकृत पत्त्यावर पोस्टद्वारे
          पाठवू शकता.
        </p>

        <h2>५. शुल्क (Fee)</h2>
        <p>
          माहिती अधिकार अर्जासोबत शासनाने निर्धारित केलेले अर्ज शुल्क भरावे लागते.
          अतिरिक्त प्रतांसाठी प्रति पान प्रमाणे शुल्क आकारले जाऊ शकते. शुल्काबाबत अधिक
          माहितीकरिता कृपया ग्रामपंचायत कार्यालयाशी संपर्क साधा.
        </p>

        <h2>६. माहिती मिळण्याचा कालावधी</h2>
        <p>
          साधारणतः अर्ज प्राप्त झाल्यापासून ३० दिवसांच्या आत मागितलेली माहिती उपलब्ध
          करून देणे आवश्यक आहे. विलंब झाल्यास कायद्यानुसार अपील करण्याचा अधिकार
          अर्जदारास आहे.
        </p>

        <h2>७. संपर्क</h2>
        <p>
          माहिती अधिकारासंबंधित अधिक माहितीसाठी किंवा अर्ज जमा करण्यासाठी कृपया
          तांडा ग्रामपंचायत कार्यालयात संपर्क साधा. कार्यालयाचा पत्ता आणि वेळ याबाबत
          माहिती "संपर्क" पृष्ठावर दिली आहे.
        </p>
      </div>
    </div>
  );
};

export default RTI;
